import React from "react";
import Alert from "@material-ui/lab/Alert";
const Information = (props) => { 
  const { success, message } = props;
  if (success !== undefined) {
    if (success) {
      return <Alert severity="success">{message.toString()}</Alert>;
    } else if (message) {
      return <Alert severity="error">{message.toString()}</Alert>;
    }
    else {
      return null;
    }
  } else {
    return null;
  }
};

export default Information;
